import { ReactNode, createContext, useContext, useMemo, useState, SetStateAction } from 'react';

export type RenderPageType = 'home-page' | 'explorer-home-page';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface JobExplorerContextType {
  setRenderPage: (values: SetStateAction<RenderPageType>) => void;
  renderPage: RenderPageType;
}
const defaultContextValues = {
  setRenderPage: () => null,
  renderPage: 'home-page' as const,
};
const HomeContext = createContext<JobExplorerContextType | null>(defaultContextValues);
const HomeContextProvider = ({ children }: { children: ReactNode }) => {
  const { setRenderPage, renderPage } = useHomeExplorerPageToggler();
  const value = useMemo(
    () => ({
      setRenderPage,
      renderPage,
    }),
    [renderPage, setRenderPage]
  );
  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
};
const useHomeContext = () => {
  const context = useContext(HomeContext);
  if (!context) throw new Error('useHomeContext has to be used within <HomeContext.Provider>');
  return useMemo(() => context, [context]);
};
export { HomeContextProvider, useHomeContext };
const useHomeExplorerPageToggler = () => {
  const [renderPage, setRenderPage] = useState<RenderPageType>('home-page');
  return {
    renderPage,
    setRenderPage,
  };
};
export const useHomeRender = () => {
  const { renderPage } = useHomeContext();
  const isExplorerHomePage = useMemo(() => renderPage === 'explorer-home-page', [renderPage]);
  return {
    isExplorerHomePage,
  };
};
